import { ReactNode } from 'react';
import styled from 'styled-components';

import { PRIMARY_TEXT_COLOUR, SECONDARY_TEXT_COLOUR } from 'theme';
import { useLocation, useNavigate } from 'react-router-dom';
import { OnboardingAnswers } from '../../../../api';
import { GradientButton } from '../../../../components';
import { BASE_KAJABI_ROUTE } from '../../../../const';

const Wrapper = styled.div`
  background-color: #ffffff;
  width: 570px;
  height: fit-content;
  max-height: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 60px;
  @media (max-width: 550px) {
    padding: 32px;
  }

  border-radius: 20px;
  text-align: center;
`;
const Title = styled.div`
  margin-top: 16px;
  font-weight: 600;
  font-size: 30px;
  line-height: 36px;
  color: ${PRIMARY_TEXT_COLOUR};
`;
const Subtitle = styled.div`
  margin-top: 16px;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: ${SECONDARY_TEXT_COLOUR};
`;

const StyledButton = styled(GradientButton)`
  margin-top: 34px;
`;

interface OnboardingDoneProps {
  icon?: ReactNode;
  title?: string;
  subtitle?: string;
  redirectToBuilder?: boolean;
}

const CALENDLY_MEMBER_VALUES = ['500 - 1,000', '1,000 - 3,000', '3,000+'];
const CALENDLY_FOLLOWER_VALUES = ['1M +'];

const isCalendlyShown = (values: OnboardingAnswers) => {
  const { DataSource, FollowerCount, MemberCount } = values;
  if (DataSource) {
    if (['Kajabi', 'VHX'].includes(DataSource)) {
      return false;
    }
  }
  if (MemberCount) {
    return CALENDLY_MEMBER_VALUES.includes(MemberCount);
  }
  if (FollowerCount) {
    return CALENDLY_FOLLOWER_VALUES.includes(FollowerCount);
  }
  return false;
};

export const OnboardingDone = ({ icon, title, subtitle, redirectToBuilder }: OnboardingDoneProps) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const values = state ? (state as OnboardingAnswers) : undefined;
  const showCalendly = values && isCalendlyShown(values);

  if (redirectToBuilder) {
    window.location.href = window.location.origin;
    return null;
  }

  return (
    <Wrapper>
      {icon}
      <Title>{title}</Title>
      {showCalendly ? (
        <>
          <Subtitle>
            To help you make the most of VidApp, the next step is to book in a call with our success team.
          </Subtitle>
          <StyledButton onClick={() => navigate(`${BASE_KAJABI_ROUTE}/call`)}>Book In A Call</StyledButton>
        </>
      ) : (
        <Subtitle>{subtitle}</Subtitle>
      )}
    </Wrapper>
  );
};
